// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const ArrowDownward = React.forwardRef(function ArrowDownward(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></SvgIcon>;
});
export default ArrowDownward;
